import { Validators } from "@angular/forms";
import { FormField } from "../../../core/models/form/form-field.model";

export const LOGIN_RESELLER_FORM: { [key: string]: FormField } = {
    email: {
        id: 'email',
        type: 'email',
        name: 'email',
        label: 'Email',
        placeholder: "Inserisci la tua email",
        value: '',
        data: [],
        validators: [Validators.required, Validators.email],
        errorMessages: {
            required: "Inserire l'email.",
            email: "Inserire un'email valida."
        }
    },
    password: {
        id: 'password',
        type: 'password',
        name: 'password',
        label: 'Password',
        placeholder: "Digita la password",
        value: '',
        data: [],
        validators: [Validators.required],
        errorMessages: {
            required: "Password obbligatoria",
            passwordNotStrong: "La password deve contenere almeno 8 caratteri, con almeno una lettera maiuscola, una minuscola, un numero e un carattere speciale "
        }
    }
}